export const FEATURE_FLAGS_CONSTANT = {
  TEAMS_ORG_SR: 'ff_teams_org_s_r',
} as const;

export type FeatureFlagKey =
  (typeof FEATURE_FLAGS_CONSTANT)[keyof typeof FEATURE_FLAGS_CONSTANT];
